import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { AppBar, SxProps, Theme, Toolbar } from '@mui/material';
import InsightLogo from 'shared/components/InsightLogo';
import { UserMenu } from './UserMenu';

const toolbarLoggedOutStyles: SxProps<Theme> = {
  justifyContent: 'flex-start',
};
const toolbarLoggedInStyles: SxProps<Theme> = {
  justifyContent: 'space-between',
};

export const AppHeader = () => {
  const { instance } = useMsal();
  const authenticated = useIsAuthenticated();
  const logout = () => {
    instance.logout();
  };
  return (
    <AppBar position='sticky'>
      <Toolbar sx={authenticated ? toolbarLoggedInStyles : toolbarLoggedOutStyles}>
        <InsightLogo />
        {authenticated && <UserMenu logout={logout} />}
      </Toolbar>
    </AppBar>
  );
};
